/** @format */

import { CommonModule } from '@angular/common';
import { HomrBannerComponent } from './homr-banner.component';
import { MediaModule } from '@shared/media/components';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [HomrBannerComponent],
	imports: [CommonModule, MediaModule],
	exports: [HomrBannerComponent]
})
export class HomrBannerModule {}
